// eslint-disable-next-line import/prefer-default-export
export enum MediaType {
  AUDIO = "audio",
  VIDEO = "video",
}
